import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiPencil, mdiPlus } from "@mdi/js";

import Edit from "Resources/ImagesNew/IconTable/iconEdit.png";
import { ModalThongBaoSua } from "./ModalThongBaoSua";

export const BtnSua = ({ item, setFilterCookie, index }) => {
  const [isModalClose, setModalClose] = useState(false);
  const CloseModal = () => {
    setModalClose(!isModalClose);
  };
  const EditBH = (sCode) => {
    setFilterCookie();
    window.location.href = "/DatHang?Id=" + sCode;
  };
  return (
    <>
      <a
        id={"btnSuaDonHang" + index}
        href={() => false}
        class="iconTable-Main"
        onClick={(e) => EditBH(item.OrderDatHangID)}
      >
        <img src={Edit} title="Sửa" alt="" />
      </a>

      {isModalClose && <ModalThongBaoSua CloseModal={CloseModal} item={item} />}
    </>
  );
};
